<template>
  <div class="newsmobilebox">
    <transition name="slide-fade">
      <top_mobile v-show="topshow"></top_mobile>
    </transition>
    <div class="top1">
      <img src="../../public/statics/img/mobile/newtop.png" alt="">
    </div>

    <div class="newlist" v-for="item in listdata">
      <div class="newlistl"> {{ item.time.year }}年{{ item.time.month }}月</div>
      <div class="newlistr">
        <p class="newlistr1">{{ item.title }}!</p>
        <p class="newlistr2">{{ item.times }}</p>
        <p class="newlistr3">{{ item.content }}</p>
        <span class="newlistr4" @click="toshowdetail(item.id)">查看详情</span>
      </div>
    </div>
    <div class="more" v-if="page_now<page_total">
      <span @click="getmore()"> 显示更多资讯</span>
      <img src="../../public/statics/img/mobile/icon_youjiantou@2x.png" alt="">
    </div>


    <div style="width: 100%;height:40px;"></div>
    <botmob></botmob>


  </div>

</template>

<script>
import top_mobile from "../components/top_mobile";
import botmob from "../components/botmobile";
import news from "../../public/statics/newsdata"

export default {
  name: "newviews_mobile",
  data() {
    return {
      topshow: true,
      //分页信息
      pageall: 0, //总条数
      pagesize: 0, //每页多少条
      page_now: 1, //当前页,
      page_total: 0, //总页数
      currentPage: 1, //初始页
      //数据
      listdata: [],
      listdataall: [],
    }
  },
  components: {
    top_mobile, botmob
  },
  created() {
    this.listdataall = news.newslist;
  },
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      console.log(from);
      if (!from.fullPath.includes('newviewsdetails_mobile?id')) {
        console.log(111);
        vm.listdata = [];
        vm.page_now = 1;
        vm.getnew(1);
      }
    })
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollx, true)
    // this.getnew(this.page_now);
  },
  methods: {
    handleScrollx() {
      if (window.pageYOffset > 60) {
        this.topshow = false;
      } else {
        this.topshow = true;
      }
      ;
    },
    toshowdetail(e) {
      if (e > 9) {
        this.$router.push({
          path: '/news_view_mobile',
          query: {
            url: this.listdataall[this.listdataall.length - e - 1].url
          }
        })
        return false
      }

      this.$router.push({
        path: '/newviewsdetails_mobile',
        query: {id: e}
      })
    },
    getnew(page) {
      this.page_now = Number(page);
      this.pagesize = 2;
      this.page_total = Math.ceil(this.listdataall.length / this.pagesize);
      let left = this.page_now * this.pagesize - this.pagesize;
      let right = this.page_now * this.pagesize;
      this.listdata = this.listdata.concat(this.listdataall.slice(left, right));//取出一页数据
    },
    getmore() {
      this.page_now++;
      this.getnew(this.page_now);
    },
  },


}
</script>

<style scoped lang='scss'>
.newsmobilebox {
  .top1 {
    img {
      width: 100%;
      height: auto;
    }
  }

  .newlist {
    margin: 1rem;
    padding-bottom: 1rem;
    box-sizing: border-box;
    height: auto;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ECECEC;

    .newlistl {
      width: 8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "PingFang SC";
      color: #BEBFC2;
      font-size: 14px;
    }

    .newlistr {
      width: 16rem;
      overflow: hidden;
      text-align: left;
      font-family: "PingFang SC";

      .newlistr1 {
        font-size: 16px;
        color: #333333;
        white-space: nowrap;
        text-overflow: ellipsis; /* for internet explorer */
        overflow: hidden;
        width: 100%;
        display: block;
      }

      .newlistr2 {
        font-size: 12px;
        color: #B6B5B5;
        margin-top: 0.5rem;
      }

      .newlistr3 {
        font-size: 14px;
        color: #999999;
        margin-top: 0.5rem;
        letter-spacing: 0;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2; /*要显示的行数*/
        -webkit-box-orient: vertical;
      }

      .newlistr4 {
        display: block;
        margin-top: 1rem;
        color: #53B5DE;
      }

    }
  }


  .more {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 14px;
    padding: 0 1rem 1rem;
    box-sizing: border-box;
    color: #77D0F5;
    font-family: "PingFang SC";

    img {
      margin-left: 10px;
      width: auto;
      height: 14px;
    }
  }
}

</style>
